export const youtubeLinkValidate = new RegExp(
  /^(https:\/\/)?((www.)?youtube.com|youtu.be)\//
);

export const getYoutubeThumbnailByVideoId = (videoId: string) =>
  `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;

export const getYoutubeVideoIdByUrl = (url: string) => {
  if (url.indexOf('youtube.com/watch?') !== -1) {
    return url
      .split('?')[1]
      .split(/&|#/)
      .map((value) => value.split('='))
      .find((search) => search[0] === 'v')?.[1];
  }

  if (
    url.indexOf('youtu.be') !== -1 ||
    url.indexOf('youtube.com/embed') !== -1 ||
    url.indexOf('youtube.com/v/') !== -1
  ) {
    return url.split('/').pop()?.split('?')[0];
  }
};

export const getYoutubeThumbnailByUrl = (url: string) => {
  const videoId = getYoutubeVideoIdByUrl(url);
  if (!videoId) return;
  const thumbnailUrl = getYoutubeThumbnailByVideoId(videoId);
  return thumbnailUrl;
};
